<div *ngIf="currentView === 'paymentApproved'" class="dependents">
  <div class="success-container">
    <img src="assets/images/success-icon.png" alt="Icon copiar" />
    <h1>Recarga efetuada com sucesso!</h1>
    <button (click)="navigateToHome()" mat-raised-button class="confirma">
      Voltar para o início
    </button>
  </div>
</div>

<div *ngIf="currentView === 'showPix'" class="dependents">
  <div class="container-qrcode">
    <ng-container *ngIf="remainingTime > 0; else qrCodeExpired">
      <h2>Pedido aguardando pagamento!</h2>
      <p>
        Faça pagamento pelo seu banco favorito e sua recarga será
        <b>validada automaticamente</b>.
      </p>
      <div class="container-pix">
        <img [src]="qrcodeImage" alt="QR Code Pix" class="pix-qr-code" />
        <div class="qrcode-info">
          <span
            ><b>R$ {{ getTotalRecharge() || "R$ 0,00" }}</b></span
          >
          <span
            >Expira em: <b>{{ remainingTime | minutesSeconds }}</b></span
          >
        </div>
      </div>
      <div class="container-qrcode-footer">
        <div *ngIf="qrCodeLink">
          <div class="qr-code-content">{{qrCodeLink}}</div>
        </div>
        <button (click)="copyQrCodeLink()" mat-raised-button class="confirma btn-copiar">
          <img src="assets/images/copiar-icon.png" alt="Icon copiar" /> Copiar
          código
        </button>
      </div>
      <button (click)="cancelPix()" mat-raised-button class="confirma">
        Cancelar Pix
      </button>
    </ng-container>
    <ng-template #qrCodeExpired>
      <h2>Pedido aguardando pagamento!</h2>
      <p>
        Faça pagamento pelo seu banco favorito e sua recarga será
        <b>validada automaticamente</b>.
      </p>
      <div class="container-pix">
        <div class="pix-qr-code inactive" style="filter: blur(2px)">
          <img
            src="assets/images/qrcode-aluno.png"
            alt="QR Code Pix"
            class="pix-qr-code"
          />
        </div>
        <div class="qrcode-info">
          <span
            ><b>R${{ getTotalRecharge() || "R$ 0,00" }}</b></span
          >
        </div>
      </div>
      <div class="message-alert">
        <p>
          <img src="assets/images/alert-icon.png" alt="Icon alerta" /> QR Code
          expirado
        </p>
      </div>
      <button (click)="pixRecharge()" mat-raised-button class="confirma">
        Gerar novo QR Code
      </button>
    </ng-template>
  </div>
</div>

<div *ngIf="currentView === 'rechargeForm'" class="dependents">
  <ul>
    <li>
      <div class="cabecalho user">
        <div class="nomeDependente nameUser">
          <h2>
            {{ dependent.NomeTitular }}<br />
            <span class="subtitulo">
              {{ dependent.NomeDoLocal }}
            </span>
          </h2>
        </div>
        <div class="saldo">
          <span>R$ {{ dependent.Saldo }}</span>
        </div>
      </div>

      <div class="mensagem-bloqueio" *ngIf="!enableRecharge">
        <p>A recarga desse estabelecimento foi desabilitada.</p>
        <p>Para mais informações, favor entrar em contato com a Cantina.</p>
      </div>
      <div *ngIf="enableRecharge">
        <p class="codigo textoPagamento">Selecione a forma de recarga</p>

        <div>
          <div class="dependents">
            <div class="row-left">
              <div class="listItem">
                <div class="box-slide">
                  <div
                    *ngIf="hasPaymentMethods"
                    (click)="creditCard = true; bankslip = false; pix = false"
                    class="money-box"
                    [ngClass]="{
                      'money-box-color-active': creditCard,
                      'money-box-color-deactive': !creditCard
                    }"
                  >
                    <div class="button is-border box-home button-home padding-btn">
                      Cartão
                    </div>
                  </div>

                  <div
                    *ngIf="!hasPaymentMethods"
                    (click)="goToCard(general / registrarCartao)"
                    class="money-box money-box-color-deactive">
                    <div class="button is-border box-home button-home padding-btn">
                      Cadastrar cartão de crédito
                    </div>
                  </div>

                  <div
                    (click)="pix = true; creditCard = false; bankslip = false"
                    class="money-box"
                    [ngClass]="{
                      'money-box-color-active': pix || !hasPaymentMethods,
                      'money-box-color-deactive': !pix && hasPaymentMethods
                    }"
                  >
                    <div class="button is-border box-home button-home padding-btn">
                      PIX
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="pix || creditCard || bankslip" class="recarga">
            <h2 class="valor-recarga">
              Digite o valor da recarga<br />
              <span class="valor-recarga">
                <app-input-currency
                  [inputModel]="rechargeModel.amountInputModel"
                  (isInputValid)="setFormStatus($event, 'creditCardNumber')"
                  [(value)]="rechargeModel.amountToShow"
                ></app-input-currency>
              </span>
            </h2>
            <span
              class="info-taxa"
              *ngIf="rechargeModel.dependent.ValorTaxaRecarga > 0"
            >
              Taxa administrativa: R$
              {{
                rechargeModel.dependent.ValorTaxaRecarga.toLocaleString(
                  "pt-BR",
                  { maximumFractionDigits: 2, minimumFractionDigits: 2 }
                )
              }}
            </span>
          </div>

          <div *ngIf="!pix && bankslip && dependent.CobrarTaxaUsuarioPorBoleto">
            <div class="dadosCartao">
              <div class="codigo">
                <p style="font-size: 13px">
                  * Para recargas com boleto, sera cobrada uma
                  <span class="taxa-tl"
                    >taxa de
                    {{
                      dependent.ValorTaxaUsuarioPorBoleto | currency : "R$"
                    }}</span
                  >.<br />
                </p>
              </div>
            </div>
          </div>

          <div *ngIf="creditCard && hasPaymentMethods">
            <div class="dadosCartao">
              <div class="list-menu">
                <ul>
                  <li>
                    <div class="form-text">
                      <app-input-select
                        [children]="paymentMethods"
                        [placeholder]="'Selecione o cartão de crédito'"
                        [validators]="['required']"
                        (isInputValid)="setFormStatus($event, 'paymentMethod')"
                        [(value)]="paymentMethod"
                        class="mat-form-fieldmat-form-field-infix"
                        >Método de Pagamento</app-input-select
                      >
                    </div>
                  </li>
                </ul>
              </div>

              <div class="codigo">
                <h2 class="valor-recarga">
                  Código de segurança<br />
                  <span>
                    <app-input
                      [inputModel]="rechargeModel.cvvInputModel"
                      (isInputValid)="setFormStatus($event, 'cvv')"
                      [(value)]="rechargeModel.cvv"
                    ></app-input>
                  </span>
                </h2>
              </div>
            </div>
          </div>
          <div
            class="total"
            *ngIf="rechargeModel.dependent.ValorTaxaRecarga > 0"
          >
            <h2>Total</h2>
            <p>
              Valor da recarga: {{ rechargeModel.amountToShow || "R$ 0,00" }}
            </p>
            <p>
              Valor da taxa administrativa: R$
              {{
                rechargeModel.dependent.ValorTaxaRecarga.toLocaleString(
                  "pt-BR",
                  { maximumFractionDigits: 2, minimumFractionDigits: 2 }
                )
              }}
            </p>
            <p>
              <span>Valor a ser pago: R$ {{ getTotalRecharge() }}</span>
            </p>
          </div>

          <div class="descricao-dependentes">
            <button
              *ngIf="creditCard"
              (click)="recharge()"
              [disabled]="isLoading"
              mat-raised-button
              class="confirma"
            >
              Recarregar
            </button>
            <button
              *ngIf="dependent.AceitaBoleto && bankslip"
              (click)="bankSlipRecharge()"
              mat-raised-button
              class="confirma"
            >
              Gerar boleto
            </button>
            <button
              *ngIf="pix"
              (click)="pixRecharge()"
              mat-raised-button
              class="confirma"
            >
              Gerar QR Code
            </button>
          </div>
        </div>
      </div>
    </li>
  </ul>
</div>



// WEBPACK FOOTER //
// /usr/src/app/src/app/components/recharge/recharge.component.html